// Dependencies
import React from 'react';
import {
  Layout,
  InfoList,
  HomeCarousel,
  CategoriesList,
  VehiclesCardCarousel,
  LinkIndexSegment,
  ListVehiclesPricesDetail,
  Seo,
} from '@components';
import { graphql } from 'gatsby';

export function Head({ pageContext, location }) {
  const { pathname } = location;
  const { language, messages } = pageContext.intl;

  const params = {
    locale: language,
    title: messages['seo.home.title'],
    description: messages['seo.home.description'],
    image: 'https://api.trucksur.com/static/other/trucksur_seo.jpg',
    pathname,
  };
  return <Seo {...params} />;
}

export default function IndexPage({ data, location }) {
  const offersVehicles = data.offersVehicles.edges.map(({ node }) => node);
  const lastAddedVehicles = data.lastAddedVehicles.edges.map(
    ({ node }) => node
  );
  const homePictures = data.homePictures.edges.map(({ node }) => ({
    ...node,
  }));

  const dataCarousel = homePictures
    .filter((item) => item?.fields?.image?.localFile)
    .sort((a, b) => a.orden - b.orden)
    .map((item) => {
      return {
        title: item.titulo,
        image: item.fields.image,
        href: item.enlace,
      };
    });

  return (
    <Layout>
      <div className="grid grid-cols-1">
        <HomeCarousel data={dataCarousel} />
        <CategoriesList className="md:order-first" />
        <div className="container mx-auto px-3">
          <InfoList />
        </div>

        <div className="flex flex-col gap-12 mt-16">
          <div className="flex flex-col gap-6">
            <LinkIndexSegment
              href="/ultimas-incorporaciones"
              idLabel="misc_last"
            />
            <VehiclesCardCarousel
              data={lastAddedVehicles}
              proxEntImg={data.prox_ent_img}
              interest={data.vehicleFinancial.interest}
              location={location}
            />
          </div>
          <div className="flex flex-col gap-6">
            <LinkIndexSegment href="/ofertas" idLabel="misc_offer" />
            <VehiclesCardCarousel
              data={offersVehicles}
              proxEntImg={data.prox_ent_img}
              interest={data.vehicleFinancial.interest}
              location={location}
              pagination={false}
            />
          </div>
        </div>
        <div className="container mx-auto px-3">
          <ListVehiclesPricesDetail />
        </div>
      </div>
    </Layout>
  );
}

export const query = graphql`
  {
    offersVehicles: allVehicle(
      filter: { oferta: { eq: "está en oferta" } }
      sort: { updated_at: DESC }
      limit: 4
    ) {
      edges {
        node {
          id
          titulo
          fecha_de_matriculacion
          matricula
          kms_segun_tacografo
          precio
          seo_name
          es_financiable
          financ_pvp
          financ_entrada
          financ_plazo
          financ_valor_res
          texto_garantia
          comercial {
            _id
            email
            name
            telefono
          }
          fields {
            main_image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    height: 210
                    layout: CONSTRAINED
                    placeholder: BLURRED
                  )
                }
              }
            }
          }
        }
      }
    }
    lastAddedVehicles: allVehicle(
      filter: { fields: { images: { elemMatch: { url: { ne: null } } } } }
      sort: [{ fecha_de_registro: DESC }, { updated_at: DESC }]
      limit: 4
    ) {
      edges {
        node {
          id
          titulo
          fecha_de_matriculacion
          matricula
          kms_segun_tacografo
          precio
          seo_name
          es_financiable
          financ_pvp
          financ_entrada
          financ_plazo
          financ_valor_res
          texto_garantia
          comercial {
            _id
            email
            name
            telefono
          }
          fields {
            main_image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    height: 210
                    layout: CONSTRAINED
                    placeholder: BLURRED
                  )
                }
              }
            }
          }
        }
      }
    }
    vehicleFinancial {
      interest
    }
    prox_ent_img: file(relativePath: { eq: "proxima_entrada.jpg" }) {
      childImageSharp {
        gatsbyImageData(height: 210, layout: CONSTRAINED, placeholder: BLURRED)
      }
    }
    homePictures: allHomePicture {
      edges {
        node {
          enlace
          id
          titulo
          orden
          fields {
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
                }
              }
            }
          }
        }
      }
    }
  }
`;
